import { render, staticRenderFns } from "./SubUnitForm.vue?vue&type=template&id=55f28cb4&scoped=true&"
import script from "./SubUnitForm.vue?vue&type=script&lang=ts&"
export * from "./SubUnitForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f28cb4",
  null
  
)

export default component.exports